<template>
  <div class="page-view">
    <!-- 头部内容 -->
    <div class="page-header">
      <!-- 面包屑 -->
      <a-breadcrumb class="page-breadcrumb">
        <a-breadcrumb-item>数据报表</a-breadcrumb-item>
        <a-breadcrumb-item>成员数据</a-breadcrumb-item>
      </a-breadcrumb>
      <!-- 功能条 -->
      <div class="tool-view">
        <!-- 金额范围 -->
        <div>金额范围：</div>
        <a-radio-group v-model="rangeType" @change="onRangeTypeChange">
          <a-radio-button value="true_pay">实际支出</a-radio-button>
          <a-radio-button value="order_pay">任务金额</a-radio-button>
        </a-radio-group>
        <!-- 弹簧 -->
        <div style="flex: 1;"></div>
        <!-- 时间范围 -->
        <div>时间范围：</div>
        <RangePicker
          style="width: 260px;"
          @change="onTimeChange"
          :allowClear="false"
          :defaultValue="[moment(times[0]), moment(times[1])]"
          :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
          :disabledDate="disabledDate"
        >
        </RangePicker>
      </div>
    </div>
    <!-- 页面内容 -->
    <div class="page-content page-content-pro">
      <!-- 左边内容 -->
      <div class="content-left">
        <!-- 功能条 -->
        <div class="tool-view">
          <!-- 标题 -->
          <div class="page-title">分布</div>
        </div>
        <!-- 图表 -->
        <div style="height: 300px;" :id="pieUniqueID"></div>
      </div>
      <!-- 右边内容 -->
      <div class="content-right">
        <!-- 功能条 -->
        <div class="tool-view">
          <!-- 标题 -->
          <div class="page-title">趋势</div>
          <!-- 弹簧 -->
          <div style="flex: 1;"></div>
          <!-- 时间范围 -->
          <a-dropdown>
            <span class="content-dropdown-title">
              <span v-for="item in dataTimeTypes" :key="item.value" v-show="item.value === disTimeType">按{{ item.text }}</span>
              <a-icon type="down" />
            </span>
            <a-menu slot="overlay">
              <a-menu-item
                v-for="item in dataTimeTypes"
                :key="item.value"
                @click="touchTimeSelect(item)"
              >
                按{{ item.text }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <!-- 图表 -->
        <div style="height: 300px;" :id="uniqueID"></div>
      </div>
      <!-- 加载 -->
      <Loading :loading="isLoading"></Loading>
    </div>
    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 功能条 -->
      <div class="tool-view">
        <!-- 标题 -->
        <div class="page-title">明细</div>
        <!-- 弹簧 -->
        <div style="flex: 1;"></div>
        <!-- 展示时间范围 -->
        <a-select v-model="detailTimeType" style="width: 120px;" @change="handleDetailTimeTypeChange" v-if="detailObjectType !== 0">
          <a-select-option
            v-for="item in dataTimeTypes" 
            :key="item.value"
            :value="item.value"
          >
            按{{ item.text }}展示
          </a-select-option>
        </a-select>
        <!-- 展示目标对象 -->
        <a-select
          v-model="detailObjectType"
          style="width: 120px; margin-left: 16px;"
          dropdownClassName="dropdown-box"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :showSearch="true"
          :filterOption="filterOption"
          @change="handleDetailObjectTypeChange"
        >
          <a-select-option :value="0">全部成员</a-select-option>
          <a-select-option
            v-for="item in detailObjects"
            :key="item.member_id"
            :value="item.member_id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <!-- 导出 -->
        <a-button style="margin-left: 16px;" @click="touchDetailExport">导出数据</a-button>
      </div>
      <!-- 列表 -->
      <a-table
        v-if="dataSource.length"
        :columns="columns"
        :data-source="dataSource"
        :row-key="(record, index) => index"
        :pagination="pagination"
        @change="handleTableChange"
      >
      </a-table>
      <!-- 空数据 -->
      <Empty style="height: 400px;" v-else></Empty>
      <!-- 加载 -->
      <Loading :loading="isDetailLoading"></Loading>
    </div>
  </div>
</template>

<script>
import Pub from '@/utils/public'
import { getMemberTrade, getOptionList, getMemberPie, getMemberPayList } from '@/api/request'
import { dataTimeTypes } from '@/utils/constant'
import RangePicker from '@/components/RangePicker'
import Empty from '@/components/Empty'
import Loading from '@/components/Loading'
import moment from 'moment'
import { Area, Pie } from '@antv/g2plot'
// 列字段
const columns = [
  {
    title: '日期',
    dataIndex: 'sign',
    key: 'sign'
  },
  {
    title: '支出金额',
    dataIndex: 'pay',
    key: 'pay'
  }
]
export default {
  components: {
    Empty,
    Loading,
    RangePicker
  },
  data () {
    return {
      Pub,
      dataTimeTypes,
      // 列字段
      columns,
      // 数据源
      dataSource: [],
      // 分页器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true
      },
      // 唯一标识符
      uniqueID: Pub.GetUniqueID(),
      pieUniqueID: Pub.GetUniqueID(),
      // 图表
      chart: undefined,
      pieChart: undefined,
      // 时间格式
      dateFormat: 'YYYY-MM-DD',
      // 头部 - 范围类型
      rangeType: 'true_pay',
      // 头部 - 时间范围
      times: [],
      // 分布 - 查询时间范围
      disTimeType: 1,
      // 分布 - 加载
      isLoading: false,
      // 明细 - 加载
      isDetailLoading: false,
      // 明细 - 查询时间范围
      detailTimeType: 1,
      // 明细 - 查询目标对象
      detailObjectType: 0,
      // 明细 - 查询目标对象列表
      detailObjects: []
    }
  },
  created () {
    // 初始化时间范围
    this.times = [moment().subtract(30, 'days').format(this.dateFormat), moment().format(this.dateFormat)]
  },
  mounted () {
    // 初始化图表
    this.initArea()
    this.initPie()
    // 获取数据
    this.onRangeTypeChange()
  },
  methods: {
    moment,
    // 头部 - 切换范围类型
    onRangeTypeChange () {
      // 获取饼图数据
      this.getMemberPie()
      // 获取图标数据
      this.trendList()
      // 获取明细列表数据
      this.detailObjectType = 0
      this.handleDetailTimeTypeChange()
      // 获取明细查询目标对象列表
      this.getOptionList()
    },
    // 头部 - 时间切换
    onTimeChange (date, dateString) {
      this.times = dateString
      this.onRangeTypeChange()
    },
    // 头部 - 限制只能选择最近一年
    disabledDate (current) {
      return current < moment().subtract(1, 'years') || current > moment().endOf('day')
    },
    // 趋势 - 切换时间范围
    touchTimeSelect (item) {
      this.disTimeType = item.value
      this.trendList()
    },
    // 明细 - 分页
    handleTableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.detailList()
    },
    // 明细 - 查询时间范围
    handleDetailTimeTypeChange () {
      this.pagination.current = 1
      this.detailList()
    },
    // 匹配输入的内容
    filterOption (value, option) {
      return option.componentOptions.children[0].text.indexOf(value) >= 0
    },
    // 明细 - 查询目标对象
    handleDetailObjectTypeChange (id) {
      // 选中全部时，日月周维度重置
      if (id === 0) {
        this.detailTimeType = 1
      }
      this.handleDetailTimeTypeChange()
    },
    // 获取饼图数据
    getMemberPie () {
      this.isLoading = true
      const params = {
        key: this.rangeType,
        start_at: this.times[0],
        end_at: this.times[1],
      }
      getMemberPie(params).then(res => {
        this.isLoading = false
        const { code, data } = res
        if (code === 0) {
          // 分布数据
          const pieChartDataSource = []
          data.list.forEach(item => {
            pieChartDataSource.push({
              title: item.name,
              num: item.pay,
              rate: item.percent
            })
          })
          this.pieChart.update({
            data: pieChartDataSource,
            statistic: {
              // 内容
              content: { formatter: () => {
                return Pub.MONEY_FORMAT(data.total_pay)
              }}
            }
          })
        }
      })
    },
    // 分布趋势
    trendList () {
      this.isLoading = true
      const params = {
        key: this.rangeType,
        start_at: this.times[0],
        end_at: this.times[1],
        search_type: this.disTimeType,
      }
      getMemberTrade(params).then(res => {
        this.isLoading = false
        const { code, data } = res
        if (code === 0) {
          // 趋势数据
          var chartDataSource = []
          data.list.forEach((item, index) => {
            // 标题
            var title = item.sign
            var time = undefined
            // 区分
            if (this.disTimeType === 1) {
              // 按日
              title = moment(item.sign).format('MM月DD日')
              time = moment(item.sign).format('MM-DD')
            } else if (this.disTimeType === 2) {
              // 按周
              time = `${item.year}年${item.sign}周`
              title = `${time}（${item.start} - ${item.end}）`
            } else if (this.disTimeType === 3) {
              // 按月
              time = item.sign // `${moment(item.sign).format('MM')}月`
              title = time
            }
            // 有子数据
            item.list.forEach(i => {
              // 趋势图数据插入
              chartDataSource.push({
                title: `${title}\n\n汇总：${item.total_pay}`,
                time: time || title,
                num: i.true_pay,
                group: i.name,
                rate: i.percent
              })
            })
          })
          if (!chartDataSource.length) {
            // 若此次渲染的是空数组，先销毁图表，再进行初始化（避免图表更新不彻底）
            this.chart.destroy()
            this.initArea()
          } else {
            // 更新图表数据
            this.chart.changeData(chartDataSource)
          }
        }
      }).catch(() => {
        this.isLoading = false
      })
    },
    // 查询目标对象列表
    getOptionList () {
      this.isDetailLoading = true
      const params = {
        from: 2,
        start_at: this.times[0],
        end_at: this.times[1]
      }
      getOptionList(params).then(res => {
        this.isDetailLoading = false
        const { code, data } = res
        if (code === 0) {
          this.detailObjects = data
        }
      }).catch(() => {
        this.isDetailLoading = false
      })
    },
    // 处理列字段
    setColumns () {
      if (this.detailObjectType === 0) {
        // 选择全部时，展示列字段 “部门”
        this.columns[0] = {
          title: '成员',
          dataIndex: 'name',
          key: 'name'
        }
      } else {
        this.columns[0] = {
          title: '日期',
          dataIndex: 'sign',
          key: 'sign'
        }
      }
    },
    // 按照列字段单独处理数据并返回
    setDetailList (list) {
      if (!list.length) {
        return []
      }
      // 当前是第几页
      const page = this.pagination.current
      const { detailObjectType, detailTimeType } = this
      // 全部部门，处理第一条总计数据
      if (detailObjectType === 0 && page === 1) {
        list[0].name = list[0].sign
      }
      // （单个部门 + 按周展示）处理日期格式
      if (detailObjectType !== 0 && detailTimeType === 2) {
        list.forEach((item, index) => {
          if ((page === 1 && index > 0) || page !== 1) {
            item.sign = `${item.sign}周（${item.start} - ${item.end}）`
          }
        })
      }
      return list
    },
    // 明细列表
    detailList () {
      this.isDetailLoading = true
      const params = {
        key: this.rangeType,
        start_at: this.times[0],
        end_at: this.times[1],
        c_member_id: this.detailObjectType,
        // 选择具体的 detailObjectType 选项，才传入日期类型
        search_type: this.detailObjectType !== 0 ? this.detailTimeType : undefined,
        page: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      getMemberPayList(params).then(res => {
        this.isDetailLoading = false
        const { code, data } = res
        if (code === 0) {
          // 设置列字段
          this.setColumns()
          // 处理数据
          this.dataSource = this.setDetailList(data.list)
          this.pagination.total = data.total
        }
      }).catch(() => {
        this.isDetailLoading = false
      })
    },
    // 明细 - 导出数据
    touchDetailExport () {
      this.isDetailLoading = true
      const params = {
        key: this.rangeType,
        start_at: this.times[0],
        end_at: this.times[1],
        c_member_id: this.detailObjectType,
        // 选择具体的 detailObjectType 选项，才传入日期类型
        search_type: this.detailObjectType !== 0 ? this.detailTimeType : undefined,
        page: 1,
        page_size: 10000
      }
      getMemberPayList(params).then(res => {
        this.isDetailLoading = false
        const { code, data, message } = res
        if (code === 0) {
          // 处理数据
          const list = this.setDetailList(data.list)
          // 处理列
          const columns = this.columns.map(item => {
            return {
              name: item.title,
              field: item.key
            }
          })
          // 表单 sheets
          const sheets = [
            {
              // 单个 sheet 名字
              name: `成员数据明细-${this.rangeType === 'true_pay' ? '实际支出' : '任务金额'}（${this.times[0]}-${this.times[1]}）`,
              // 单个 sheet 数据源
              data: list,
              // 单个 sheet 列名称与读取key
              columns: columns
            }
          ]
          // 开始下载
          this.$exdownload(sheets, function (item, field, json, sheetIndex, row, col, rowCount, colCount) {
            return item
          })
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.isDetailLoading = false
        this.$message.error('导出失败')
      })
    },
    // 初始化图表
    initArea () {
      // 数据源
      const dataSource = []
      // 创建
      const chart = new Area(this.uniqueID, {
        // 数据源
        data: dataSource,
        // x轴对应key，横向线
        xField: 'time',
        // y轴对应key，竖向线
        yField: 'num',
        // 分组对应 key，多组数据
        seriesField: 'group',
        // 线条是否为弧度
        smooth: true,
        // x轴配置
        xAxis: {
          // 轴头尾留空白
          range: [0, 1]
        },
        // x轴配置
        yAxis: {
          label: {
            // 处理Y轴数值展示
            formatter: (v) => {
              if (v > 1000) {
                return `${(v / 1000).toFixed(1)}K`
              } else {
                return v
              }
            }
          }
        },
        // 提示
        tooltip: {
          // 标题，设置的值，如果为字段key，则会从数据源中取值显示，如果数据源没有该key，则直接显示
          title: 'title',
          // 是否显示 hover 辅助线
          showCrosshairs: true,
          // 需要用到数据源的哪些字段，在这里列出
          fields: ['group', 'num', 'rate'],
          // 处理弹窗数值展示
          formatter: (datum) => {
            return { name: datum.group, value: datum.num, rate: datum.rate }
          },
          // 自定义 item 模板：每项记录的默认模板，自定义模板时必须包含各个 dom 节点的 class。
          itemTpl: `
            <li class="g2-tooltip-list-item">
              <span class="g2-tooltip-marker" style="background-color: {color};"></span>
              <span class="g2-tooltip-name">{name}</span>:
              <span class="g2-tooltip-value">{value}<span style="margin-left: 16px; color: #ccc">{rate}</span></span>
            </li>
          `,
          // 辅助线配置
          crosshairs: {
            // x 表示 x 轴上的辅助线，y 表示 y 轴上的辅助线，xy 表示两条辅助线
            type: 'x',
            // 辅助线是否跟随鼠标移动
            follow: false,
            // 辅助线配置
            line: {
              // 样式配置
              style: {
                // 线宽
                lineWidth: 0.5
              }
            }
          }
        },
        // 图例列表
        legend: {
          // y轴偏移
          offsetY: 5,
          // 摆放位置
          position: 'bottom',
          // 图例高度
          itemHeight: 28,
          // 配置图例
          marker: {
            // 图例样式
            style: (style) => {
              // 重组样式
              return {
                // 半径
                r: 3,
                // 样式类型
                symbol: 'circle',
                // 填充
                fill: style.fill || style.stroke,
                // 边框线宽
                lineWidth: 1,
                // 边框填充颜色
                stroke: style.fill || style.stroke,
                // 边框透明度
                strokeOpacity: 1,
                // 线圆角
                lineCap: 'round',
                lineJoin: 'round'
              }
            }
          }
        },
        // 主题配置
        theme: {
          // 分类个数小于 10 时使用
          colors10: ['#638DFF', '#79E7FF', '#1BCE78', '#FBD437', '#D6D6D6']
          // 分类个数大于 10 时使用
          // colors20: ['#A685FF', '#FBD86D']
        },
        // 动画配置
        // https://g2plot.antv.vision/zh/docs/api/options/animation
        animation: {
          // 配置图表第一次加载时的入场动画
          appear: {
            // 动画效果
            animation: 'wave-in',
            // 动画执行时间
            duration: 2000
          }
        }
      })
      // 记录
      this.chart = chart
      // 绘制
      chart.render()
    },
    // 初始化图表
    initPie () {
      // 数据源
      const dataSource = []
      // 创建
      const chart = new Pie(this.pieUniqueID, {
        // 数据源
        data: dataSource,
        // 扇形切片大小（弧度）所对应的数据字段名
        angleField: 'num',
        // 扇形颜色映射对应的数据字段名
        colorField: 'title',
        //  画布宽高的最小值比例作为半径（0-1）
        radius: 1,
        // 内半径，也算是显示进度条宽度
        innerRadius: 0.8,
        // 四周间距，用于点击扇形时，动画移出所需要占用的空间
        appendPadding: 18,
        // 添加交互（'default' | 'active' | 'inactive' | 'selected'）
        interactions: [
          // 选中样式
          // { type: 'element-selected' }
          // 激活样式
          // { type: 'element-active' }
        ],
        // 清空扇形上的数据提示
        label: false,
        // 扇形样式
        pieStyle: {},
        // 隐藏图例
        legend: false,
        // 静态内容
        statistic: {
          // 标题
          title: {
            content: '总金额',
            style: {
              'fontSize': '14px',
              'color': 'rgba(0, 0, 0, 0.45)',
              'marginTop': '-10px'
            }
          },
          // 内容样式
          content: {
            // 样式
            style: {
              color: 'rgba(0, 0, 0, 0.85)',
              fontSize: '24px',
              lineHeight: '40px',
              fontWeight: '500'
            },
            // 内容
            formatter: () => '0'
          }
        },
        // 提示
        tooltip: {
          // 需要用到数据源的哪些字段，在这里列出
          fields: ['title', 'num', 'rate'],
          // 处理弹窗数值展示
          formatter: (datum) => {
            return { name: datum.title, value: datum.num, rate: datum.rate }
          },
          // 自定义 item 模板：每项记录的默认模板，自定义模板时必须包含各个 dom 节点的 class。
          itemTpl: `
            <li class="g2-tooltip-list-item">
              <span class="g2-tooltip-marker" style="background-color: {color};"></span>
              <span class="g2-tooltip-name">{name}</span>:
              <span class="g2-tooltip-value">{value}<span style="margin-left: 16px; color: #ccc">{rate}</span></span>
            </li>
          `
        },
        // 主题配置
        theme: {
          // 分类个数小于 10 时使用
          colors10: ['#638DFF', '#79E7FF', '#1BCE78', '#FBD437', '#D6D6D6']
          // 分类个数大于 10 时使用
          // colors20: ['#A685FF', '#FBD86D']
        }
      })
      // 记录
      this.pieChart = chart
      // 绘制
      chart.render()
    }
  }
}
</script>

<style>
.page-header .ant-divider-vertical {
  height: 40px;
}
</style>
<style lang="less" scoped>
.page-view {
  background-color: #F0F2F5;
  height: 100%;
}
.page-header {
  padding: 24px 32px;
  background-color: #fff;
}
.page-header .tool-view {
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.page-content {
  position: relative;
  margin-top: 24px;
  padding: 24px 32px;
  background-color: #fff;
}
.page-content .tool-view {
  padding-bottom: 24px;
  display: flex;
  align-items: center;
}
.page-content .page-title {
  font-size: 16px;
  color: #333333;
}
.page-content-pro {
  display: flex;
}
.page-content-pro .content-left {
  width: 40%;
}
.page-content-pro .content-right {
  width: 60%;
}
.page-content {
  /deep/ .dropdown-box {
    width: 180px !important;
  }
}
</style>